import React from 'react';

export default function AlertSuccess ({ msg }) {
    return (
        <div className="alert alert-success show" role="alert">
            {msg}
        </div>
    );
}